module.exports = __webpack_public_path__ + "static/media/import.82becdf5.csv";